import script from "./TicketItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketItem.vue?vue&type=script&setup=true&lang=ts"

import "./TicketItem.vue?vue&type=style&index=0&id=14db36b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14db36b0"]])

export default __exports__